const API_END_POINT = `${window.location.protocol}//${window.location.hostname}`
export const API_END_POINT_FORM_CONTATO = `${API_END_POINT}/submit-form-contato`
export const API_END_POINT_FORM_PARCEIROS = `${API_END_POINT}/submit-form-parceiros`